import React from "react";
import * as PropTypes from "prop-types";
import { maritalStatusPropType } from "../propTypes";
import FormControl from "@mui/material/FormControl";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import NativeSelect from "@mui/material/NativeSelect";
import { withTranslation } from "react-i18next";

const MaritalStatusSelector = ({ t, ...rest }) => (
    <div className={rest.className}>
        <FormControl>
            <InputLabel
                variant="standard"
                htmlFor="input"
                shrink={true}
            >
                {t(rest.label)}
            </InputLabel>

            <NativeSelect
                input={<Input id="input" />}
                value={rest.value}
                onChange={(e) => rest.onChange(e.target.value)}
            >
                <option value="married">{t("Married")}</option>
                <option value="unmarried">{t("Unmarried")}</option>
                <option value="all_women">{t("All women")}</option>
            </NativeSelect>
        </FormControl>
    </div>
);

MaritalStatusSelector.propTypes = {
    label: PropTypes.string,
    value: maritalStatusPropType,
    className: PropTypes.string,
    onChange: PropTypes.func.isRequired,
};

MaritalStatusSelector.defaultProps = {
    label: "Marital status",
};

export default withTranslation()(MaritalStatusSelector);
